import React from 'react';
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const validationSchema = Yup.object().shape({
  codigo_usuario: Yup.number()
    .nullable()
    .required('Selecione um usuário.'),
  nivel: Yup.number()
    .typeError('Nível deve ser >= 1.')
    .min(1, 'Nível deve ser >= 1.')
    .integer('Nível deve ser um número inteiro.')
    .required('Nível deve ser >= 1.'),
});

const INITIAL_VALUES = {
  codigo_usuario: null,
  usuario_nome: '',
  nivel: 1,
};

const FormIncluirNivel = ({ tipo, onSuccess }) => {
  const carregarUsuarios = (inputValue, callback) => {
    api
      .buscarUsuarioOptions('ativos')
      .then((res) => {
        const lista = res || [];
        const toOpt = (u) => {
          const nome = u.nome_completo
            ? u.nome_completo
            : u.nome
            ? u.nome
            : u.nome_usuario
            ? u.nome_usuario
            : '';
          return {
            value: u.codigo_usuario,
            label: u.codigo_usuario + ' - ' + nome,
          };
        };
        const filtrados = inputValue
          ? lista.filter((u) => {
              const nome = u.nome_completo || u.nome || u.nome_usuario || '';
              return nome.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
            })
          : lista;
        callback(filtrados.slice(0, 50).map(toOpt));
      })
      .catch(() => callback([]));
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    api
      .incluirHierarquiaContaSalario({
        codigo_usuario: values.codigo_usuario,
        nivel: Number(values.nivel),
        tipo,
      })
      .then(() => {
        toast.success('Usuário incluído na hierarquia.');
        resetForm();
        onSuccess();
      })
      .catch((err) => {
        const msg = err && err.message ? err.message : 'Erro ao incluir usuário.';
        toast.error(msg);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleSubmit: formikSubmit,
        handleChange,
        handleBlur,
        setFieldValue,
        setFieldTouched,
        isSubmitting,
      }) => (
        <Form noValidate onSubmit={formikSubmit} className="mb-3">
          <Row className="align-items-end">
            <Col md={6}>
              <Form.Group className="mb-0">
                <Form.Label>Usuário</Form.Label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={carregarUsuarios}
                  placeholder="Pesquisar usuário..."
                  loadingMessage={() => 'Carregando...'}
                  noOptionsMessage={() => 'Nenhum usuário encontrado'}
                  onChange={(option) => {
                    setFieldValue('usuario_nome', option ? option.label : '', false);
                    setFieldValue('codigo_usuario', option ? option.value : null);
                    setFieldTouched('codigo_usuario', true, false);
                  }}
                  value={
                    values.codigo_usuario
                      ? { value: values.codigo_usuario, label: values.usuario_nome }
                      : null
                  }
                  isClearable
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                />
                {touched.codigo_usuario && errors.codigo_usuario && (
                  <div className="text-danger" style={{ fontSize: '0.875em', marginTop: 4 }}>
                    {errors.codigo_usuario}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-0">
                <Form.Label>Nível</Form.Label>
                <Form.Control
                  type="number"
                  name="nivel"
                  min={1}
                  value={values.nivel}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.nivel && !!errors.nivel}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nivel}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Button
                variant="primary"
                type="submit"
                disabled={isSubmitting}
                block
              >
                {isSubmitting ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  '+ Incluir'
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default FormIncluirNivel;
